<template>
    <div id="user-mail-list">
        <button class="new-email-button" @click="newEmail">
            <span class="new-email-title">{{ $t("mail.newMail") }}</span>
        </button>
        <div class="header">
            <a-input-search
                v-model:value="searchValue"
                placeholder="input search text"
                style="width: 100% !important"
                @input="onSearch($event)"
            />
            <div class="toolbar">
                <div class="tabs">
                    <div class="item" :class="[selected === 'all' && 'selected']" @click="mailListAll">
                        All
                        <span class="count">{{ allMailCounts }}</span>
                    </div>
                    <div class="item" :class="[selected === 'unread' && 'selected']" @click="mailListUnread">
                        Unread
                        <span class="count">{{ unreadMails.length }}</span>
                    </div>
                </div>
                <div class="actions">
                    <span class="material-icons" style="font-size: 20px; cursor: pointer" @click="refresh">replay</span>
                </div>
            </div>
        </div>
        <md-progress-bar class="md-accent" :md-mode="isDeterminate"></md-progress-bar>
        <div class="mails">
            <div v-for="email of filterMailList" v-if="filterMailList.length > 0">
                <div
                    class="item"
                    :class="[selectedUserMailThreadId === email.thread_id && 'selected']"
                    @click="getMailDetail(email.thread_id)"
                >
                    <span class="unread-circle" v-if="email.isUnread.length > 0"></span>
                    <div class="avatar">
                        <span class="avatar-name">{{ email.sender ? email.sender.slice(0, 1) : "" }}</span>
                    </div>
                    <div class="metas">
                        <div class="left">
                            <div class="name">{{ email.sender }}</div>
                            <div class="subject">
                                <span class="subject-name">Subject: </span>
                                <span>{{ email.subject }}</span>
                            </div>
                            <div class="body">
                                <span class="content-name">Content: </span>
                                <span>{{ email.body_text }}</span>
                            </div>
                        </div>
                        <div class="right">{{ email.created_at ? email.created_at.slice(0, 10) : "" }}</div>
                    </div>
                </div>
            </div>
            <div class="material-icons get-mails" @click="getLoadMore" v-if="filterMailList.length !== allMailCounts">
                add_circle_outline
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { log2 } from "../../../../utils/log2";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";

const log = log2("MailBox");
export default {
    name: "MailBox",
    components: {},
    props: {
        refreshMailList: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selected: "all",
            searchValue: "",
            mailList: [],
            pageCount: 1,
            perPage: 20,
            isDeterminate: "determinate",
            unreadMails: [],
            filterMailList: [],
            allMailCounts: 0,
            isSearchValueEmpty: true,
            departmentMail: "",
            mailDetails: [],
        };
    },
    computed: {
        ...mapState({
            selectedUserMailThreadId: (state) => state.mail.selectedUserMailThreadId,
            user: (state) => state.auth.user,
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        isMailReadPermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.read"].tr.name);
        },
        isMailCreatePermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.create"].tr.name);
        },
    },
    methods: {
        ...mapActions({
            getMailListAction: "mail/getMailList",
            getUserMailList: "mail/getUserMailList",
            getMailDetails: "mail/getMailDetails",
            cleanUnreadThread: "mail/cleanUnreadThread",
            getAllUnreadMailCount: "mail/getAllUnreadMailCount",
        }),
        ...mapMutations({
            USER_SELECTED_MAIL: "mail/USER_SELECTED_MAIL",
        }),
        async onSearch(e) {
            console.log("onSearch...", e.target.value);
            this.isSearchValueEmpty = e.target.value.length === 0;
            if (e.target.value.length !== 0) {
                if (e.target.value.length !== 0) {
                    this.filterMailList = await this.getMyMails(this.pageCount, this.perPage, e.target.value);
                }
            }
        },
        newEmail() {
            if (!this.isMailCreatePermission) {
                this.$message.error(this.$t("noPermission"));
                return;
            } else {
                this.$emit("visible-composer", true);
            }
        },
        mailListAll() {
            this.selected = "all";
            this.filterMailList = this.mailList;
        },
        mailListUnread() {
            this.selected = "unread";
            this.filterMailList =
                this.mailList.length > 0 ? this.mailList.filter((mail) => mail.isUnread.length > 0) : [];
        },
        async getMailDetail(threadId) {
            this.$emit("visible-composer", false);
            if (!!threadId) {
                this.mailDetails = await this.getMailDetails(threadId);
                await this.cleanUnreadThread({ userId: this.user._id, threadId });
                await this.getAllUnreadMailCount(this.user._id);
                this.USER_SELECTED_MAIL(threadId);
            }
        },
        async getMyMails(pageCount = this.pageCount, perPage = this.perPage, searchValue = "") {
            const type = this.$route.params.type;
            if (type === "user") {
                return this.getUserMailList({
                    userId: this.user._id,
                    mailAddressId: this.$route.params.id,
                    pageCount,
                    perPage,
                    searchValue,
                }).then((res) => {
                    this.allMailCounts = res.count || 0;
                    this.unreadMails = res.mails.filter((x) => !!x.isUnread).map((x) => x.lastMail) || 0;
                    return res.mails.map((x) => x.lastMail) || [];
                });
            } else {
                return this.getMailListAction({
                    incoming: false,
                    userId: this.user._id,
                    mailAddress: this.departmentMail.mail,
                    pageCount,
                    perPage,
                    searchValue: "",
                }).then((res) => {
                    this.allMailCounts = res.count || 0;
                    this.unreadMails = res.mails.filter((x) => !!x.isUnread).map((x) => x.lastMail) || 0;
                    return res.mails.map((x) => x.lastMail) || [];
                });
            }
        },
        async refresh() {
            this.filterMailList = await this.getMyMails();
        },
        async getLoadMore() {
            this.pageCount += 1;
            this.isDeterminate = "indeterminate";
            const result = await this.getMyMails();
            if (this.mailList.length > 0) this.mailList = [...this.mailList, ...result];

            if (this.selected === "unread") {
                this.filterMailList =
                    this.mailList.length > 0 ? this.mailList.filter((mail) => mail.isUnread.length > 0) : [];
            } else {
                this.filterMailList = this.mailList;
            }
            this.isDeterminate = "determinate";
        },
    },

    async mounted() {
        console.log("this.allMailAddresses...", this.allMailAddresses);
        this.departmentMail = this.allMailAddresses.find(
            (email) => email.department && email.department._id === this.$route.params.id
        );
        this.filterMailList = await this.getMyMails();
        await this.getMailDetail(this.filterMailList.length > 0 ? this.filterMailList[0].thread_id : "");
    },

    watch: {
        refreshMailList(val) {
            console.log("refreshMailList...", val);
            this.refresh();
        },
        mailDetails(val) {
            this.$emit("mailDetails", val);
        },
        selectedUserMailThreadId(val) {
            this.getMailDetail(val);
        },
    },
};
</script>

<style lang="scss">
#user-mail-list {
    max-width: 400px;
    flex: 0 0 400px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #c7d0d7;

    .ant-popover-inner-content {
        padding: 5px 5px 3px 5px;
    }

    .md-accent {
        background: #bfeadb;

        .md-progress-bar-fill::after {
            background-color: #009688 !important;
        }

        .md-progress-bar-track::after {
            background-color: #009688 !important;
        }
    }

    .new-email-button {
        width: 100%;
        color: #fff;
        background-color: #009688;
        border-radius: 4px;
        padding: 6px 16px;
        border: none;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
            0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
            box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

        &:hover {
            background-color: rgb(0, 105, 95);
            box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
                0px 1px 10px 0px rgba(0, 0, 0, 0.12);
        }

        .new-email-title {
            text-transform: uppercase;
        }
    }

    .header {
        display: flex;
        padding: 20px 20px 0;
        margin-bottom: 5px;
        grid-gap: 5px;
        flex-flow: column;
        max-height: 116px;

        .toolbar {
            display: flex;
            justify-content: space-between;
            grid-gap: 10px;
            gap: 10px;
            align-items: center;

            .tabs {
                display: flex;
                grid-gap: 5px;
                gap: 5px;

                .item {
                    padding: 5px;
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    align-items: center;
                    box-shadow: none;
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: -0.24px;
                    line-height: 24px;
                    border-radius: 4px;

                    &.selected {
                        background-color: #c7d0d7;
                        color: #5a5f72;
                    }

                    .count {
                        display: inline-block;
                        font-size: 11px;
                        font-weight: 700;
                        line-height: 16px;
                        padding: 0 4px;
                        border-radius: 4px;
                        height: fit-content;
                        background: #fff;
                        min-width: fit-content;
                    }
                }
            }
        }

        .actions {
            .mail-detail {
                cursor: pointer;
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                .mail-detail-item {
                    margin-left: 5px;
                }

                &:hover {
                    background-color: #edf1f4;
                    padding: 3px 5px 3px 5px !important;
                }
            }
        }
    }

    .mails {
        overflow-x: hidden;
        height: calc(100vh - 350px);
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        max-width: 100%;
        width: 100%;

        .get-mails {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            font-size: 35px;
            cursor: pointer;
        }

        .item {
            display: flex;
            align-items: center;
            position: relative;
            margin-right: 1px;
            border: none;
            border-radius: 0;
            padding: 16px;
            cursor: pointer;
            grid-gap: 5px;
            gap: 5px;
            border-bottom: 1px solid #c7d0d7;

            &:hover {
                background-color: #edf1f4;
            }

            &.selected {
                background-color: #d1ecde6e;
                border-left: 4px solid #009688;
            }

            .unread-circle {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #009688;
            }

            .avatar {
                vertical-align: middle;
                width: 30px;
                height: 30px;
                border-radius: 25px;
                font-family: Helvetica, Arial, sans-serif;
                background-color: #8d5cc6;
                display: flex;
                justify-content: center;
                align-items: center;

                .avatar-name {
                    font-size: large;
                    color: white;
                    font-weight: 500;
                }
            }
        }

        .metas {
            display: flex;
            justify-content: space-between;
            width: 90%;

            .left {
                display: flex;
                flex-direction: column;

                .name {
                    font-weight: 600;
                    font-size: 14px;
                }

                .subject {
                    font-size: 12px;
                    font-weight: 400;

                    .subject-name {
                        font-weight: 600;
                    }
                }

                .body {
                    font-size: 12px;
                    font-weight: 400;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    width: 200px;

                    .content-name {
                        font-weight: 600;
                    }
                }
            }

            .right {
            }
        }
    }
}
</style>
